@switch (state()) {
  @case ('overpaid') {
    <i class="fa-regular fa-piggy-bank text-red-700 text-lg"
       [pTooltip]="overpaidTooltip()"
       tooltipPosition="top"
       data-testid="prepaid-indicator-overpaid"></i>
  }
  @case ('prepaid') {
    <i class="fa-regular fa-piggy-bank text-green-700 text-lg"
       pTooltip="Prepaid TA"
       tooltipPosition="top"
       data-testid="prepaid-indicator-prepaid"></i>
  }
  @case ('flightOnly') {
    <i class="fa-solid fa-plane text-surface-600 text-[16px] pl-0.5"
       pTooltip="Flights Only TA"
       tooltipPosition="top"
       aria-label="Flights Only TA"
       data-testid="flight-indicator"></i>
  }
}
